import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ModalGenericPostCancelContainer from "../../../Common/ModalGenericPostCancelContainer";

import {
    getMiljogebyr as getMiljogebyrAction,
    putMiljogebyrIsKvalitetsikret as putMiljogebyrIsKvalitetsikretAction,
} from "../../../../actions/miljogebyrerActions";

export default function GodkjennContainer({ reloadHistorikk }) {
  const miljogebyr = useSelector((state) => state.miljogebyr);
  const dispatch = useDispatch();

  const getMiljogebyr = (id) => dispatch(getMiljogebyrAction(id));
  const putMiljogebyrIsKvalitetsikret = (id, params) =>
    dispatch(putMiljogebyrIsKvalitetsikretAction(id, params));

  const handleApiCall = async (miljogebyrId) => {
    return await putMiljogebyrIsKvalitetsikret(miljogebyrId, {
      isKvalitetsikret: true,
    })
      .then(() => {
        getMiljogebyr(miljogebyr.id);
        reloadHistorikk();
        return Promise.resolve();
      })
      .catch((error) => Promise.reject(error));
  };

  if (miljogebyr.isMaKvalitetsikres && !miljogebyr.isMakulert) {
    return (
      <ModalGenericPostCancelContainer
        id={miljogebyr.id}
        submitButtonText="Godkjenn miljøgebyr"
        submittingButtonText="Godkjenner miljøgebyr..."
        successPostCallFlashMessage="Endring fullført"
        errorPostCallFlashMessage="Endring feilet"
        handleApiCall={handleApiCall}
        modalTitle={`Godkjenn miljøgebyr ${miljogebyr.ileggelsesnummer}`}
        openModalComponentFunction={(props) => (
          <Button
            className="btn btn-bym-standard"
            style={{ marginLeft: 20 }}
            onClick={props.openModal}
          >
            Godkjenn
          </Button>
        )}
      >
        <p>{`Vil du godkjenne miljøgebyr ${miljogebyr.ileggelsesnummer}?`}</p>
      </ModalGenericPostCancelContainer>
    );
  }
  return <span />;
}

GodkjennContainer.propTypes = {
  reloadHistorikk: PropTypes.func,
};
